module.exports = __webpack_public_path__ + "img/home1.85e882ac.jpg";